import React from 'react';
import LeftBar from '../Components/LeftBar';
import Dashnav from '../Components/Dashnav';
import AdminsComp from './AdminsComp';

function Admins() {
  return (
    <div className='mainContainer'>
      <LeftBar />
      <div className='theMainContainer'>
        <Dashnav />
        <AdminsComp />
      </div>
    </div>
  );
}

export default Admins;
